// import { Box, VStack, IconButton, HStack, Text } from '@chakra-ui/react';
// import { useState } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import { FaTimes } from 'react-icons/fa';
// import {
//     download,
//     label,
//     oBIcons,
//     order,
//     searchIcon,
//     star,
// } from '../../pages/dashboard/components/Icons';
// import PublishModal from './PublishModal';
// import useGetUserDetails from 'hooks/useGetUserDetail';
// import logo from '../../assets/bigLogo.svg';
// import { useDispatch } from 'react-redux';
// import { logoutUser } from '../../redux/actions/authActions';

// const MobileMenu = ({ isModalOpen, closeModal, userDetails }) => {
//     const navigate = useNavigate();
//     const dispatch = useDispatch();

//     const handleLogout = () => {
//         logoutUser(dispatch);
//         navigate('/');
//     };
//     const location = useLocation();
//     let title = location.pathname;

//     const user = useGetUserDetails();
//     var decoded = user?.flattenedUser;
//     const details = decoded?.attributes;

//     const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
//     const closePublishModal = () => setIsPublishModalOpen(false);

//     return (
//         <>
//             <Overlay isOpen={isModalOpen} onClick={closeModal} />

//             <SidebarContainer isOpen={isModalOpen}>
//                 <SidebarHeader>
//                     <HStack spacing="12px" width="100%">
//                         <Box>
//                             <img
//                                 src={logo}
//                                 alt="Logo"
//                                 style={{ width: '50px', height: '50px', objectFit: 'contain' }}
//                             />
//                         </Box>
//                         <VStack align="start" spacing="2px" flex="1">
//                             <Text fontSize="16px" fontWeight="600" color="#1b3b5f" lineHeight="1.2">
//                                 {details?.first_name || 'User'}
//                             </Text>
//                             <Text fontSize="12px" color="#718096" lineHeight="1.2">
//                                 {decoded?.email || 'user@example.com'}
//                             </Text>
//                         </VStack>
//                         <IconButton
//                             icon={<FaTimes />}
//                             onClick={closeModal}
//                             variant="ghost"
//                             size="sm"
//                             aria-label="Close menu"
//                             color="#1b3b5f"
//                             _hover={{ bg: 'rgba(33, 33, 241, 0.1)' }}
//                         />
//                     </HStack>
//                 </SidebarHeader>

//                 <MenuContent>
//                     <VStack spacing="8px" align="stretch">
//                         <MenuLink to="/dashboard" isActive={title === '/dashboard'}>
//                             <Box display="flex" alignItems="center" gap="12px" onClick={closeModal}>
//                                 {searchIcon} <span>Dashboard</span>
//                             </Box>
//                         </MenuLink>

//                         <MenuLink
//                             to="/dashboard/products"
//                             isActive={title.includes('/dashboard/products')}>
//                             <Box display="flex" alignItems="center" gap="12px" onClick={closeModal}>
//                                 {star} <span>Products</span>
//                             </Box>
//                         </MenuLink>

//                         <MenuLink
//                             to="/dashboard/import"
//                             isActive={title.includes('/dashboard/import')}>
//                             <Box display="flex" alignItems="center" gap="12px" onClick={closeModal}>
//                                 {download} <span>WishList</span>
//                             </Box>
//                         </MenuLink>

//                         <MenuLink
//                             to="/dashboard/orders"
//                             isActive={title.includes('/dashboard/orders')}>
//                             <Box display="flex" alignItems="center" gap="12px" onClick={closeModal}>
//                                 {label} <span>Order</span>
//                             </Box>
//                         </MenuLink>

//                         <MenuLink
//                             to="/dashboard/wallet"
//                             isActive={title.includes('/dashboard/wallet')}>
//                             <Box display="flex" alignItems="center" gap="12px" onClick={closeModal}>
//                                 {label} <span>Transactions</span>
//                             </Box>
//                         </MenuLink>

//                         <MenuLink to="/dashboard/cart" isActive={title.includes('/dashboard/cart')}>
//                             <Box display="flex" alignItems="center" gap="12px" onClick={closeModal}>
//                                 {order} <span>My Cart</span>
//                             </Box>
//                         </MenuLink>

//                         <MenuLink to="/dashboard/crm" isActive={title.includes('/dashboard/crm')}>
//                             <Box display="flex" alignItems="center" gap="12px" onClick={closeModal}>
//                                 {oBIcons.crm} <span>CRM</span>
//                             </Box>
//                         </MenuLink>
//                          {/* Custom Sourcing – external link */}
// <Box
//     as="a"
//     href="https://obana.africa/custom-sourcing"   // use https
//     target="_blank"
//     rel="noopener noreferrer"
//     onClick={closeModal}
//     display="block"
//     padding="12px 16px"
//     borderRadius="8px"
//     fontSize="16px"
//     fontWeight="500"
//     color="#4a5568"
//     background="transparent"
//     transition="all 0.2s ease"
//     textDecoration="none"
//     _hover={{
//         background: '#f7fafc',
//         transform: 'translateX(4px)',
//     }}
//     sx={{
//         '& svg': {
//             width: '20px',
//             height: '20px',
//             '& path': { stroke: '#718096', transition: 'stroke 0.2s ease' },
//         },
//         '&:hover svg path': { stroke: '#1b3b5f' },
//     }}
// >
//     <Box display="flex" alignItems="center" gap="12px">
//         {label}  {/* you may replace with a custom‑sourcing icon if available */}
//         <span>Custom Sourcing</span>
//     </Box>
// </Box>
//                         <MenuLink
//                             to="/dashboard/coming-soon"
//                             isActive={title.includes('/dashboard/store')}>
//                             <Box display="flex" alignItems="center" gap="12px" onClick={closeModal}>
//                                 {star} <span>Create Store</span>
//                             </Box>
//                         </MenuLink>
//                         <LogoutSection>
//                             <Text onClick={handleLogout}>Log out</Text>
//                         </LogoutSection>
//                     </VStack>
//                 </MenuContent>

//                 <PublishModal
//                     isModalOpen={isPublishModalOpen}
//                     closeModal={closePublishModal}
//                     closeMain={closeModal}
//                 />
//             </SidebarContainer>
//         </>
//     );
// };

// export default MobileMenu;

// // Styled Components
// const Overlay = styled.div`
//     position: fixed;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background: rgba(0, 0, 0, 0.5);
//     z-index: 999;
//     opacity: ${(props) => (props.isOpen ? '1' : '0')};
//     visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
//     transition: opacity 0.3s ease, visibility 0.3s ease;
// `;

// const SidebarContainer = styled.div`
//     position: fixed;
//     top: 0;
//     left: 0;
//     height: 100vh;
//     width: 280px;
//     max-width: 85vw;
//     background: #ffffff;
//     z-index: 1000;
//     box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
//     transform: translateX(${(props) => (props.isOpen ? '0' : '-100%')});
//     transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//     display: flex;
//     flex-direction: column;
//     overflow-y: auto;
// `;

// const SidebarHeader = styled.div`
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 20px 18px;
//     border-bottom: 1px solid #e2e8f0;
//     background: #ffffff;
// `;

// const MenuContent = styled.div`
//     flex: 1;
//     padding: 16px 12px;
//     overflow-y: auto;
// `;

// const MenuLink = styled(Link)`
//     display: block;
//     padding: 12px 16px;
//     border-radius: 8px;
//     font-size: 16px;
//     font-weight: 500;
//     color: ${(props) => (props.isActive ? '#1b3b5f' : '#4a5568')};
//     background: ${(props) => (props.isActive ? 'rgba(33, 33, 241, 0.1)' : 'transparent')};
//     transition: all 0.2s ease;
//     text-decoration: none;

//     &:hover {
//         background: ${(props) => (props.isActive ? 'rgba(33, 33, 241, 0.1)' : '#f7fafc')};
//         transform: translateX(4px);
//     }

//     svg {
//         width: 20px;
//         height: 20px;

//         path {
//             stroke: ${(props) => (props.isActive ? '#1b3b5f' : '#718096')};
//             transition: stroke 0.2s ease;
//         }
//     }

//     span {
//         font-weight: ${(props) => (props.isActive ? '600' : '500')};
//     }
// `;
// const LogoutSection = styled.div`
//     padding: 20px 18px;
//     border-top: 1px solid #e2e8f0;
//     text-align: left;

//     p,
//     span,
//     div,
//     button,
//     a,
//     h1,
//     h2,
//     h3 {
//         cursor: pointer;
//     }

//     span,
//     p {
//         color: #e53e3e;
//         font-weight: 600;
//         font-size: 16px;
//     }

//     &:hover {
//         background: #fff5f5;
//     }
// `;

import { useMemo, memo, useCallback } from 'react';
import {
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerBody,
    Box,
    Flex,
    // HStack,
    VStack,
    IconButton,
    Image,
    Text,
} from '@chakra-ui/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FaTimes } from 'react-icons/fa';

import {
    download,
    label,
    oBIcons,
    order,
    searchIcon,
    star,
} from '../../pages/dashboard/components/Icons';
import useGetUserDetails from 'hooks/useGetUserDetail';
import { logoutUser } from '../../redux/actions/authActions';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS — matches Navigation / Dashboard / Auth files
   ───────────────────────────────────────────────────────────── */

const NAVY        = '#1B3B5F';
// const NAVY_DEEP   = '#0F2940';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';
const DANGER      = '#E53E3E';

const FONT = "'Bricolage Grotesque', sans-serif";

const NAVY_ACTIVE_BG = 'rgba(27, 59, 95, 0.08)';

/* ─────────────────────────────────────────────────────────────
   EXTERNAL URLs — staging vs production
   ───────────────────────────────────────────────────────────── */

const CUSTOM_SOURCING_URL =
    process.env.NODE_ENV === 'production'
        ? 'https://obana.africa/custom-sourcing'
        : 'https://staging.obana.africa/custom-sourcing';

/* ─────────────────────────────────────────────────────────────
   MENU ITEMS — single source of truth.
   Each item: { label, path, icon, external?: boolean, href?: string }
   ───────────────────────────────────────────────────────────── */

const MENU_ITEMS = [
    { key: 'dashboard',    label: 'Dashboard',       path: '/dashboard',           icon: searchIcon, exact: true },
    { key: 'products',     label: 'Products',        path: '/dashboard/products',  icon: star },
    { key: 'wishlist',     label: 'Wishlist',        path: '/dashboard/import',    icon: download },
    { key: 'orders',       label: 'Orders',          path: '/dashboard/orders',    icon: label },
    { key: 'transactions', label: 'Transactions',    path: '/dashboard/wallet',    icon: label },
    { key: 'cart',         label: 'My Cart',         path: '/dashboard/cart',      icon: order },
    { key: 'crm',          label: 'CRM',             path: '/dashboard/crm',       icon: oBIcons?.crm },
    {
        key: 'custom-sourcing',
        label: 'Custom Sourcing',
        external: true,
        href: CUSTOM_SOURCING_URL,
        icon: label,
    },
    { key: 'store',        label: 'Create Store',    path: '/dashboard/coming-soon', icon: star, badge: 'SOON' },
];

/* ─────────────────────────────────────────────────────────────
   ACTIVE STATE HELPER
   ───────────────────────────────────────────────────────────── */

const isItemActive = (item, pathname) => {
    if (item.external) return false;
    if (item.exact) {
        return pathname === item.path || pathname === `${item.path}/`;
    }
    return pathname.startsWith(item.path);
};

/* ─────────────────────────────────────────────────────────────
   AVATAR — uses real user image, falls back to initials
   ───────────────────────────────────────────────────────────── */

const Avatar = memo(function Avatar({ src, name }) {
    const initial = useMemo(() => {
        if (!name) return '?';
        return name.charAt(0).toUpperCase();
    }, [name]);

    if (src) {
        return (
            <Box
                w="44px"
                h="44px"
                borderRadius="full"
                overflow="hidden"
                flexShrink={0}
                border="1px solid"
                borderColor={BORDER}
            >
                <Image
                    src={src}
                    alt={name || 'User'}
                    w="full"
                    h="full"
                    objectFit="cover"
                />
            </Box>
        );
    }

    return (
        <Flex
            w="44px"
            h="44px"
            borderRadius="full"
            bg={CYAN}
            color={NAVY}
            align="center"
            justify="center"
            fontWeight="800"
            fontSize="16px"
            fontFamily={FONT}
            flexShrink={0}
        >
            {initial}
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   MENU ITEM — handles both internal links and external URLs
   ───────────────────────────────────────────────────────────── */

const MenuItem = memo(function MenuItem({ item, isActive, onClick }) {
    const sharedProps = {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        p: '12px 14px',
        borderRadius: '10px',
        fontSize: '14px',
        fontWeight: isActive ? '700' : '500',
        color: isActive ? NAVY : MUTED,
        bg: isActive ? NAVY_ACTIVE_BG : 'transparent',
        textDecoration: 'none',
        transition: 'background 0.15s ease, color 0.15s ease',
        _hover: {
            bg: isActive ? NAVY_ACTIVE_BG : SURFACE_ALT,
            color: NAVY,
        },
        _active: {
            bg: NAVY_ACTIVE_BG,
        },
        sx: {
            '& svg': {
                width: '20px',
                height: '20px',
                flexShrink: 0,
            },
            '& svg path': {
                stroke: isActive ? NAVY : FAINT,
                transition: 'stroke 0.15s ease',
            },
            '&:hover svg path': {
                stroke: NAVY,
            },
        },
        onClick,
    };

    const content = (
        <>
            {item.icon}
            <Text as="span" flex="1" minW="0" noOfLines={1}>
                {item.label}
            </Text>
            {item.badge && (
                <Text
                    as="span"
                    fontSize="9px"
                    fontWeight="800"
                    color={NAVY}
                    bg={CYAN}
                    px="6px"
                    py="2px"
                    borderRadius="4px"
                    letterSpacing="0.06em"
                >
                    {item.badge}
                </Text>
            )}
        </>
    );

    if (item.external) {
        return (
            <Box
                as="a"
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${item.label} (opens in new tab)`}
                {...sharedProps}
            >
                {content}
            </Box>
        );
    }

    return (
        <Box
            as={Link}
            to={item.path}
            aria-current={isActive ? 'page' : undefined}
            {...sharedProps}
        >
            {content}
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   MAIN
   ───────────────────────────────────────────────────────────── */

const MobileMenu = ({ isModalOpen, closeModal }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    /* Single source of user details — no duplicate hook call */
    const { flattenedUser } = useGetUserDetails();
    const details = flattenedUser?.attributes;

    const displayName = useMemo(
        () => details?.first_name || flattenedUser?.email?.split('@')[0] || 'User',
        [details?.first_name, flattenedUser?.email]
    );

    const displayEmail = useMemo(
        () => flattenedUser?.email || details?.email || '',
        [flattenedUser?.email, details?.email]
    );

    const avatarSrc = details?.user_image || details?.user_imgage || null;

    const handleLogout = useCallback(() => {
        closeModal();
        logoutUser(dispatch);
        navigate('/');
    }, [dispatch, navigate, closeModal]);

    return (
        <Drawer
            isOpen={isModalOpen}
            placement="left"
            onClose={closeModal}
            size="xs"
            autoFocus={false}
        >
            <DrawerOverlay bg="blackAlpha.500" />
            <DrawerContent
                maxW="280px"
                bg={SURFACE}
                fontFamily={FONT}
            >
                <DrawerBody p="0" display="flex" flexDir="column">

                    {/* User profile row — clickable to navigate to profile */}
                    <Flex
                        align="center"
                        gap="10px"
                        p="14px 16px"
                        borderBottom="1px solid"
                        borderColor={BORDER}
                        bg={SURFACE_ALT}
                    >
                        <Flex
                            as={Link}
                            to="/dashboard/profile/user"
                            onClick={closeModal}
                            align="center"
                            gap="10px"
                            flex="1"
                            minW="0"
                            p="4px"
                            m="-4px"
                            borderRadius="8px"
                            cursor="pointer"
                            textDecoration="none"
                            transition="background 0.15s ease"
                            _hover={{ bg: SURFACE }}
                            _active={{ bg: BORDER }}
                            _focusVisible={{
                                outline: `2px solid ${NAVY}`,
                                outlineOffset: '2px',
                            }}
                            aria-label="View your profile"
                        >
                            <Avatar src={avatarSrc} name={displayName} />
                            <Box flex="1" minW="0">
                                <Text
                                    fontSize="13px"
                                    fontWeight="700"
                                    color={INK}
                                    lineHeight="1.2"
                                    noOfLines={1}
                                >
                                    {displayName}
                                </Text>
                                <Text
                                    fontSize="11px"
                                    color={MUTED}
                                    lineHeight="1.2"
                                    mt="2px"
                                    noOfLines={1}
                                >
                                    {displayEmail}
                                </Text>
                            </Box>
                        </Flex>
                        <IconButton
                            icon={<FaTimes />}
                            onClick={closeModal}
                            variant="ghost"
                            size="sm"
                            aria-label="Close menu"
                            color={MUTED}
                            borderRadius="8px"
                            _hover={{ bg: SURFACE, color: INK }}
                            flexShrink={0}
                        />
                    </Flex>

                    {/* MENU ITEMS */}
                    <Box
                        flex="1"
                        overflowY="auto"
                        p="10px 10px"
                    >
                        <VStack as="nav" spacing="2px" align="stretch" aria-label="Main navigation">
                            {MENU_ITEMS.map((item) => (
                                <MenuItem
                                    key={item.key}
                                    item={item}
                                    isActive={isItemActive(item, pathname)}
                                    onClick={closeModal}
                                />
                            ))}
                        </VStack>
                    </Box>

                    {/* LOGOUT */}
                    <Box
                        borderTop="1px solid"
                        borderColor={BORDER}
                        p="14px 16px"
                    >
                        <Flex
                            as="button"
                            type="button"
                            onClick={handleLogout}
                            align="center"
                            gap="10px"
                            w="full"
                            p="10px 12px"
                            borderRadius="10px"
                            bg="transparent"
                            color={DANGER}
                            fontSize="13px"
                            fontWeight="700"
                            fontFamily={FONT}
                            cursor="pointer"
                            transition="background 0.15s ease"
                            _hover={{ bg: '#FFF5F5' }}
                            _active={{ bg: '#FED7D7' }}
                            aria-label="Sign out of your account"
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <Text as="span">Log out</Text>
                        </Flex>
                    </Box>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
};

export default MobileMenu;